module.exports = __webpack_public_path__ + "static/assets/9de20e634c9ef6eb73bc2a057892061c.svg";